<h2 mat-dialog-title>
  {{ getMeatTypeName(data.quota.meatType) }}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="quota-summary">
    <div class="summary-item">
      <span class="label">{{ 'quotaDetailsDialog.totalLimit' | translate }}</span>
      <span class="value">{{ data.quota.totalLimitVolume | kgToTons }}</span>
    </div>
    <div class="summary-item">
      <span class="label">{{ 'quotaDetailsDialog.allocated' | translate }}</span>
      <span class="value">{{ data.quota.allocatedVolume | kgToTons }}</span>
    </div>
    <div class="summary-item">
      <span class="label">{{ 'quotaDetailsDialog.remainder' | translate }}</span>
      <span class="value">{{ data.quota.remainderVolume | kgToTons }}</span>
    </div>
  </div>

  <h3>{{ 'quotaDetailsDialog.approvedApplications' | translate }} ({{ data.applications.length }})</h3>

  @if (data.applications.length === 0) {
    <p class="no-data">{{ 'quotaDetailsDialog.noApprovedApplications' | translate }}</p>
  } @else {
    <div class="table-container">
      <table mat-table [dataSource]="data.applications" class="applications-table">
        <!-- № -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>№</th>
          <td mat-cell *matCellDef="let app">{{ app.id }}</td>
        </ng-container>

        <!-- Номер заявки -->
        <ng-container matColumnDef="applicationNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.applicationNumber' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.applicationNumber }}</td>
        </ng-container>

        <!-- Компания -->
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.companyName' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.companyName }}</td>
        </ng-container>

        <!-- ИНН -->
        <ng-container matColumnDef="companyInn">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.companyInn' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.companyInn }}</td>
        </ng-container>

        <!-- Номер доверенности -->
        <ng-container matColumnDef="proxyDocumentNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.proxyNumber' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.proxyDocumentNumber || '-' }}</td>
        </ng-container>

        <!-- Дата доверенности -->
        <ng-container matColumnDef="proxyDocumentDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.proxyDate' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.proxyDocumentDate || '-' }}</td>
        </ng-container>

        <!-- Дата ВРМСХ -->
        <ng-container matColumnDef="vetServiceIssueDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.vrmsxDate' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.vetServiceIssueDate || '-' }}</td>
        </ng-container>

        <!-- Номер ВРМСХ -->
        <ng-container matColumnDef="vetServiceIssueNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.vrmsxNumber' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.vetServiceIssueNumber || '-' }}</td>
        </ng-container>

        <!-- ФИО Заявителя -->
        <ng-container matColumnDef="applicantFullName">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.applicantName' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.applicantFullName }}</td>
        </ng-container>

        <!-- Номер паспорта -->
        <ng-container matColumnDef="applicantPassportNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.passportNumber' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.applicantPassportNumber }}</td>
        </ng-container>

        <!-- Номер телефона -->
        <ng-container matColumnDef="applicantPhoneNumber">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.phoneNumber' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.applicantPhoneNumber }}</td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="applicantEmail">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.email' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.applicantEmail }}</td>
        </ng-container>

        <!-- Тип мяса -->
        <ng-container matColumnDef="meatType">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.meatType' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ getMeatTypeName(app.meatType) }}</td>
        </ng-container>

        <!-- Объем -->
        <ng-container matColumnDef="requestedVolume">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.requestedVolume' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.requestedVolume | kgToTons }}</td>
        </ng-container>

        <!-- За 9 месяцев -->
        <ng-container matColumnDef="volumeForLastNineMonths">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.for9months' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.volumeForLastNineMonths | kgToTons }}</td>
        </ng-container>

        <!-- За 12 месяцев -->
        <ng-container matColumnDef="volumeForLastTwelveMonths">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.for12months' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.volumeForLastTwelveMonths | kgToTons }}</td>
        </ng-container>

        <!-- Тип поставщика -->
        <ng-container matColumnDef="supplierType">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.supplierType' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.supplierType | supplierType }}</td>
        </ng-container>

        <!-- ВРМСХ -->
        <ng-container matColumnDef="veterinaryDocumentStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.vrmsx' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.veterinaryDocumentStatus | vetDocStatus }}</td>
        </ng-container>

        <!-- Статус квоты -->
        <ng-container matColumnDef="quotaStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.quotaStatus' | translate }}</th>
          <td mat-cell *matCellDef="let app">{{ app.quotaStatus | quotaStatus }}</td>
        </ng-container>

        <!-- Статус заявки -->
        <ng-container matColumnDef="applicationStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'applicationsRegister.applicationStatus' | translate }}</th>
          <td mat-cell *matCellDef="let app">
            <span class="status-chip" [ngClass]="app.applicationStatus | statusClass">
              {{ app.applicationStatus | statusLabel }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="close()">{{ 'quotaDetailsDialog.close' | translate }}</button>
</mat-dialog-actions>
